import API from "@/services/api";

export default{
    addClass(params){
        return API().post(`classes`,params);
    },
    getClasses(){
        return API().get(`classes`);
    },
    getClassById(id){
        return API().get(`classes/${id}`);
    },
    getClassTeacher(id){
        return API().get(`classes/${id}/teacher`);
    },
    getClassStudents(id){
        return API().get(`classes/${id}/students`);
    },
    getTrainerClass(uuid){
        return API().get(`classes/${uuid}/trainer`);
    },
    updateClass(params){
        return API().put(`classes`,params);
    },
    editClass(id,params){
        return API().put(`classes/${id}`,params);
    },
    updateClassStudent(params){
        return API().put(`classes/student/edit`,params);
    },
    deleteClass(id){
        return API().get(`classes/delete/${id}`);
    }
}